import { DEFAULT_NORMAL_ICON_COLOR } from '../../dataFlow';
import { IIconInfo, IMAGE_TYPE } from '../../interface';

const defaultIconInfo: IIconInfo = {
    iconType: IMAGE_TYPE.SVG,
    iconName: '',
    normalIcon: '',
    activeIcon: '',
    color: '#FA9494',
};

const onTransformData = (info: IIconInfo) => {
    const isSvg = info.iconType === IMAGE_TYPE.SVG;
    return isSvg
        ? {
              svg: {
                  normal_url: info.svgUrl || '',
                  normal_color: info.normalColor || DEFAULT_NORMAL_ICON_COLOR,
                  icon_name: info.iconName,
                  selected_url: info.activeSvgUrl || '',
                  selected_color: info.color,
              },
          }
        : {
              custom: {
                  normal_url: info.normalIcon,
                  selected_url: info.activeIcon,
              },
          };
};
export { defaultIconInfo, onTransformData };
